import React from 'react';
import HelpArticle from '../../components/help/HelpArticle';

const SecurePayment: React.FC = () => {
  const content = (
    <>
      <h2>Sikker betaling</h2>
      <p>
        Selvom DoMore ikke håndterer betalinger, kan du stadig handle sikkert. 
        Her er tips til at beskytte dig selv ved værktøjsleje.
      </p>

      <h3>Grundlæggende sikkerhed</h3>
      <p>
        Følg disse principper for sikker betaling:
      </p>
      <ul>
        <li><strong>Aldrig betale før du møder ejeren:</strong> Med mindre de har høj rating og mange anmeldelser</li>
        <li><strong>Dokumentér alt:</strong> Gem bevis for alle betalinger</li>
        <li><strong>Brug kun aftalt beløb:</strong> Betal kun det der står i bookingen</li>
        <li><strong>Kommunikér via DoMore:</strong> Hold al kommunikation i appen</li>
      </ul>

      <h3>Verificér den anden part</h3>
      <p>
        Før du handler penge:
      </p>

      <h4>Tjek profil</h4>
      <ul>
        <li>Se på brugerens rating</li>
        <li>Læs andre anmeldelser</li>
        <li>Kig hvor længe de har været medlem</li>
        <li>Tjek om profilen er verificeret</li>
      </ul>

      <h4>Bekræft identitet</h4>
      <ul>
        <li>Bed om at se ID når I mødes (høfligt)</li>
        <li>Tjek at navnet matcher DoMore profilen</li>
        <li>Vær opmærksom på advarselsknægn</li>
      </ul>

      <h3>Sikre betalingsmetoder</h3>
      <p>
        Vælg metoder der giver dokumentation:
      </p>

      <h4>Anbefalet: MobilePay</h4>
      <ul>
        <li>✅ Automatisk transaktionshistorik</li>
        <li>✅ Kan ikke forsvinde som kontanter</li>
        <li>✅ Navn på modtager er synligt</li>
        <li>✅ Øjeblikkelig overførsel</li>
      </ul>
      <p>
        <strong>Sikkerhedstip:</strong> Verificér at MobilePay navnet matcher DoMore profilen.
      </p>

      <h4>Anbefalet: Bankoverførsel</h4>
      <ul>
        <li>✅ Fuldt sporbart</li>
        <li>✅ Via officiel finansiel institution</li>
        <li>✅ Kan bruges som bevis</li>
        <li>⚠️ Kræver at dele kontooplysninger</li>
      </ul>
      <p>
        <strong>Sikkerhedstip:</strong> Brug besked-feltet til at skrive booking ID.
      </p>

      <h4>Acceptabelt: Kontanter</h4>
      <ul>
        <li>✅ Øjeblikkelig</li>
        <li>⚠️ Ingen automatisk dokumentation</li>
        <li>⚠️ Kan være svært at bevise senere</li>
      </ul>
      <p>
        <strong>Sikkerhedstip:</strong> Skriv ALTID en kvittering ved kontant betaling.
      </p>

      <h4>Frarådes: Ukendte apps</h4>
      <ul>
        <li>❌ Undgå at bruge apps du ikke kender</li>
        <li>❌ Vær forsigtig med internationale services</li>
        <li>❌ Ingen uregistrerede "alternative" betalingsmetoder</li>
      </ul>

      <h3>Dokumentér alle transaktioner</h3>
      <p>
        Gem altid bevis:
      </p>

      <h4>For digitale betalinger</h4>
      <ul>
        <li>Tag screenshot af transaktionen</li>
        <li>Noter transaktions-ID</li>
        <li>Gem kvittering hvis systemet sender en</li>
        <li>Arkivér med booking detaljer fra DoMore</li>
      </ul>

      <h4>For kontanter</h4>
      <ul>
        <li>Skriv en håndskrevet kvittering</li>
        <li>Begge parter skal underskrive</li>
        <li>Tag foto af kvitteringen</li>
        <li>Inkludér dato, beløb, navne og booking ID</li>
      </ul>

      <h3>Depositum sikkerhed</h3>
      <p>
        Depositum kræver ekstra opmærksomhed:
      </p>

      <h4>For lejere</h4>
      <ul>
        <li>Aftale depositum størrelse skriftligt i DoMore chatten</li>
        <li>Få klar besked om hvornår det returneres</li>
        <li>Tag billeder af værktøjet ved afhentning</li>
        <li>Husk dokumentation for depositum betaling</li>
        <li>Få kvittering ved returnering af depositum</li>
      </ul>

      <h4>For ejere</h4>
      <ul>
        <li>Kommunikér depositum-politik klart på forhånd</li>
        <li>Dokumentér værktøjets tilstand ved udlevering</li>
        <li>Vær fair - returner depositum hvis alt er OK</li>
        <li>Hvis du holder depositum, forklar hvorfor</li>
      </ul>

      <h3>Advarseltegn - Røde flag</h3>
      <p>
        Vær ekstra forsigtig hvis:
      </p>
      <ul>
        <li>🚩 Brugeren har ingen eller meget lave ratings</li>
        <li>🚩 De presser dig til at betale med det samme</li>
        <li>🚩 De vil betale mere end listet pris "for at sikre bookingen"</li>
        <li>🚩 De foreslår at handle uden for DoMore platformen</li>
        <li>🚩 De vil ikke mødes personligt</li>
        <li>🚩 De vil kun have kontanter</li>
        <li>🚩 Profilen virker falsk eller ufuldstændig</li>
        <li>🚩 De ændrer prisen efter I har aftalt</li>
      </ul>

      <h3>Beskyt dig mod fupnumre</h3>

      <h4>Overpris svindel</h4>
      <p>
        En "lejer" sender dig mere end aftalt og beder om at få forskellen retur.
      </p>
      <ul>
        <li><strong>Beskyttelse:</strong> Returner hele beløbet og bed dem sende det korrekte beløb</li>
      </ul>

      <h4>Falsk betaling</h4>
      <p>
        "Lejer" påstår de har betalt, men du har ikke modtaget noget.
      </p>
      <ul>
        <li><strong>Beskyttelse:</strong> Udlevér aldrig værktøj før betaling er verificeret i din app/bank</li>
      </ul>

      <h4>Falsk depositum krav</h4>
      <p>
        "Ejer" kræver depositum til en "DoMore konto" eller tredjepartsservice.
      </p>
      <ul>
        <li><strong>Beskyttelse:</strong> DoMore håndterer ALDRIG penge. Depositum betales kun direkte til ejeren</li>
      </ul>

      <h4>Phishing</h4>
      <p>
        Du modtager en email/besked der udgiver sig for at være fra DoMore.
      </p>
      <ul>
        <li><strong>Beskyttelse:</strong> Tjek altid afsender. DoMore beder aldrig om betalingsoplysninger via email</li>
      </ul>

      <h3>Sikre møde tips</h3>
      <p>
        Ved handling af værktøj og penge:
      </p>
      <ul>
        <li>Mød på et offentligt sted hvis muligt</li>
        <li>Mød på dagtid</li>
        <li>Tag en ven med hvis du føler dig usikker</li>
        <li>Fortæl nogen hvor du er</li>
        <li>Stol på din mavefornemmelse</li>
      </ul>

      <h3>Efter transaktionen</h3>
      <p>
        Når betaling er fuldført:
      </p>
      <ul>
        <li>Bekræft i DoMore at værktøj er hentet/returneret</li>
        <li>Efterlad en ærlig anmeldelse</li>
        <li>Arkivér al dokumentation</li>
        <li>Rapportér mistænkelig adfærd til DoMore</li>
      </ul>

      <h3>Hvis noget går galt</h3>

      <h4>Du har betalt men ikke fået værktøjet</h4>
      <ol>
        <li>Kontakt ejeren via DoMore chat</li>
        <li>Dokumentér situationen (screenshots, tidslinje)</li>
        <li>Rapportér til DoMore support</li>
        <li>Overvej at kontakte din bank/MobilePay</li>
        <li>Afgive anmeldelse</li>
      </ol>

      <h4>Du har udleveret værktøj uden betaling</h4>
      <ol>
        <li>Kontakt lejeren med påmindelse</li>
        <li>Giv en rimelig frist (24 timer)</li>
        <li>Dokumentér al kommunikation</li>
        <li>Rapportér til DoMore support</li>
        <li>Overvej polition ved alvorlig svindel</li>
      </ol>

      <h4>Depositum ikke returneret</h4>
      <ol>
        <li>Spørg ejeren hvorfor</li>
        <li>Revisér jeres aftale i chat-historik</li>
        <li>Del jeres dokumentation (billeder før/efter)</li>
        <li>Kontakt DoMore support for mægling</li>
      </ol>

      <h3>DoMore's rolle</h3>
      <p>
        DoMore kan hjælpe med:
      </p>
      <ul>
        <li>✅ Mægling ved tvister</li>
        <li>✅ At vurdere chat-historik</li>
        <li>✅ Advarsler eller blokering af svindlere</li>
        <li>✅ Vejledning om bedste praksis</li>
      </ul>

      <p>
        DoMore kan IKKE:
      </p>
      <ul>
        <li>❌ Fremtvinge betalinger</li>
        <li>❌ Refundere dig med DoMore's penge</li>
        <li>❌ Fungere som bank eller betalingstjeneste</li>
      </ul>

      <h3>Best practices sammenfatning</h3>
      <ol>
        <li>Tjek altid ratings og anmeldelser</li>
        <li>Kommunikér gennem DoMore platformen</li>
        <li>Brug dokumenterbare betalingsmetoder</li>
        <li>Gem bevis for alle transaktioner</li>
        <li>Mød sikkert og offentligt</li>
        <li>Stol på din mavefornemmelse</li>
        <li>Rapportér mistænkelig aktivitet</li>
      </ol>
    </>
  );

  return (
    <HelpArticle
      title="Sikker betaling"
      category="Betaling"
      content={content}
      relatedArticles={[
        { title: 'Håndtér betalinger', link: '/help/payment-management' },
        { title: 'Betalingsproblemer', link: '/help/payment-problems' },
      ]}
    />
  );
};

export default SecurePayment;
